import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getServices = async (salonId: string, selectedLocation: string) => {
  const { data: services, error: servicesError } = await supabase
    .from('services')
    .select('id')
    .eq('salon', salonId)
    .eq('service_location', selectedLocation);

  if (servicesError) {
    console.log('Error whilte ferching services: ', servicesError.message);
  }

  if (!services || services.length === 0) {
    return [];
  }

  const { data: servicePricingDuration, error: servicePricingDurationError } = await supabase
    .from('service_pricing_duration')
    .select('*,services(*)')
    .in(
      'service',
      services.map(service => service.id),
    );

  if (servicePricingDurationError) {
    console.log(
      'Error whilte ferching service pricing duration: ',
      servicePricingDurationError.message,
    );
  }

  return servicePricingDuration;
};

export default function useGetServicePricingDurationByVideo(salonId: string, selectedLocation: string) {
  return useQuery({
    queryKey: ['useGetServicePricingDurationByVideo', salonId, selectedLocation],
    queryFn: () => getServices(salonId, selectedLocation),
    staleTime: 0,
  });
}
